import { constants } from './../app-constants';
import { Component, OnInit } from '@angular/core';
import { OrdemServicoService } from '../service/ordem-servico.service';
import { TipoOsParamModel } from '../model/tipo-os-param.model';
import { TipoOsAtivoParamModel } from '../model';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {BuscarAmbienteIn} from '../model/buscar-ambiente-in.model';

@Component({
  selector: 'app-criar-ostipo-os',
  templateUrl: './criar-ostipo-os.component.html',
  styleUrls: ['./criar-ostipo-os.component.css']
})
export class CriarOSTipoOSComponent implements OnInit {
  tiposOs: Array<any> = [];
  tipoOsParam: TipoOsParamModel = new TipoOsParamModel();
  tipoOSAtivoParam: TipoOsAtivoParamModel = new TipoOsAtivoParamModel();
  tipoOs: any;
  ativo: any;
  ambiente: any;
  numberPage = 1;

  constructor(private loadingBar: NgxUiLoaderService,
              private ordemServicoService: OrdemServicoService) { }

  selecionarTipoOS($event) {
    this.tipoOs = $event;
    localStorage.setItem(constants.tipoosSelecionadoKey, JSON.stringify(this.tipoOs));
  }

  ngOnInit() {
    this.ativo = JSON.parse(localStorage.getItem(constants.ativoKey));
    console.log(JSON.parse(localStorage.getItem(constants.ambientes).toString()));
    this.tipoOsParam.codigoMicroarea = JSON.parse(localStorage.getItem(constants.enderecoSelecionadoKey)).codigoMicroarea;
    this.tipoOSAtivoParam.codigoMicroarea = this.tipoOsParam.codigoMicroarea;
    this.tipoOsParam.paginaAtual = this.numberPage;
    if (this.ativo === null) {
      this.tipoOsParam.apenasTipoOsEmergencial = false;
    } else {
      this.tipoOSAtivoParam.ativoId = this.ativo.ativoId;
    }

    this.listarTipoOs();
  }

  public listarTipoOs() {

    this.loadingBar.start();
    if (this.tipoOSAtivoParam.ativoId !== null && this.tipoOSAtivoParam.ativoId !== undefined) {
      this.ordemServicoService.listarTipoOSAtivo(this.tipoOSAtivoParam)
        .subscribe(response => {
          this.numberPage++;
          this.onSuccess(response.tipoOSsAuxOut);
        });
    } else {
      this.ordemServicoService.listarTipoOSs(this.tipoOsParam)
        .subscribe(response => {

          if (response.tipoOSsAuxOut.length > 0) {
            this.numberPage++;
            this.onSuccess(response.tipoOSsAuxOut);
            this.onScroll();
          }
          this.onSuccess(null);
        });
    }
  }

  onSuccess(res) {
    this.loadingBar.stop();
    if (res) {
      res.forEach(tipoServico => {
        this.tiposOs.push(tipoServico);
      });
    }
  }

  public onScroll() {
    this.tipoOsParam.paginaAtual = this.numberPage;
    this.listarTipoOs();
  }

}
